const LISTING_IMAGE_DIRECTIVE_KEYWORD = 'listing.image_data_';

const FORMAT_KEYS = ['portrait', 'story', 'landscape', 'square'];

const isListingImageDirective = (value) => {
	if (typeof value !== 'string') return false;
	return value.includes(LISTING_IMAGE_DIRECTIVE_KEYWORD);
};

export const getListingOverlayFormatsValidation = ({ pages = [], directives = {} } = {}) => {
	const formatValidity = {
		portrait: false,
		story: false,
		landscape: false,
		square: false,
	};

	FORMAT_KEYS.forEach((formatKey, index) => {
		const page = pages[index];
		const children = Array.isArray(page?.children) ? page.children : [];
		formatValidity[formatKey] = children.some((child) => {
			if (child?.type !== 'image' || !child?.id) return false;
			const directive = directives?.[child.id];
			return isListingImageDirective(directive?.src);
		});
	});

	const invalidFormats = FORMAT_KEYS.filter((key) => !formatValidity[key]);

	return {
		formatValidity,
		allValid: invalidFormats.length === 0,
		invalidFormats,
	};
};
